import { mainSiteUrl } from '@/mocks/categories';

const steps = [
  {
    step: '01',
    title: 'Browse Spreadsheet Categories',
    description: 'Explore our organized categories including Shoes, Hoodies, Jackets, Accessories, and more — each packed with verified product listings.',
  },
  {
    step: '02',
    title: 'Compare Products',
    description: 'Check community ratings, read feedback, and compare similar products side by side to make informed shopping decisions with confidence.',
  },
  {
    step: '03',
    title: 'Choose Your Favorite Finds',
    description: 'Pick the products that match your style and budget from thousands of curated spreadsheet listings updated every month.',
  },
  {
    step: '04',
    title: 'Visit Main Website',
    description: 'Head over to Kaspreadsheet.com to access the full database, get the latest updates, and start discovering products.',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            How It Works
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Getting started with the Kakobuy Spreadsheet is simple — just four easy steps
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <div key={s.step} className="relative bg-background-50 rounded-2xl p-6 md:p-7">
              <span className="font-heading text-5xl md:text-6xl font-bold text-background-200 absolute top-4 right-5 select-none">
                {s.step}
              </span>
              <div className="relative z-10">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-4">
                  <i className={`${i === 0 ? 'ri-search-line' : i === 1 ? 'ri-contrast-line' : i === 2 ? 'ri-heart-line' : 'ri-external-link-line'} text-lg`}></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">{s.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{s.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-white px-7 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Started Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}